/**
 * Format a price in centavos (Honduran Lempiras) with thousands separator.
 *   formatLempiras(150000)  => "L. 1,500.00"
 *   formatLempiras(0)       => "L. 0.00"
 *   formatLempiras(99)      => "L. 0.99"
 *
 * Uses es-HN locale (Honduras) for proper comma-as-thousands-sep.
 * Caller passes CENTS to avoid float drift.
 */
export function formatLempiras(cents: number): string {
  const amount = (cents ?? 0) / 100
  const formatted = new Intl.NumberFormat('es-HN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
  return `L. ${formatted}`
}

/**
 * Alias of formatLempiras kept for backwards compatibility with existing
 * POS code that uses formatCurrency(value_in_lempiras, not cents).
 * NOTE: this one expects the value as-is (no /100), unlike formatLempiras.
 */
export function formatCurrency(value: number): string {
  const formatted = new Intl.NumberFormat('es-HN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0)
  return `L. ${formatted}`
}

/** Same as formatLempiras but returns just the number string without "L ". */
export function formatNumber(cents: number): string {
  const amount = (cents ?? 0) / 100
  return new Intl.NumberFormat('es-HN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}
